import {
	Box, Button, Flex, FormControl, FormLabel, Input, Spinner, Text,
} from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import Card from 'components/card/Card';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as InterventionReportService from 'services/InterventionReportService';

export default function InterventionReportSettings() {

	const { keycloak } = useKeycloak();

	const [nextNumber, setNextNumberValue] = useState('');
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);

	const onSessionExpired = () => {
		toast.error("Sessione scaduta. Effettua nuovamente l'accesso.", {
			position: "bottom-right",
			onClose: () => {
				keycloak.logout();
				localStorage.removeItem("kc-token");
			}
		});
	};

	const fetchNextNumber = async () => {
		setLoading(true);
		const value = await InterventionReportService.getNextNumber(keycloak.token, onSessionExpired);
		if (value !== undefined) setNextNumberValue(String(value));
		setLoading(false);
	};

	useEffect(() => {
		fetchNextNumber();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = async () => {
		const parsed = parseInt(nextNumber, 10);
		if (!parsed || parsed < 1) {
			toast.error('Inserisci un numero valido', { position: 'bottom-right' });
			return;
		}
		setSaving(true);
		const success = await InterventionReportService.setNextNumber(keycloak.token, onSessionExpired, parsed);
		if (success) {
			toast.success('Numerazione aggiornata con successo', { position: 'bottom-right' });
		} else {
			toast.error('Errore durante l\'aggiornamento della numerazione', { position: 'bottom-right' });
		}
		setSaving(false);
	};

	return (
		<Box px='20px' mb="0px" maxW="420px">
			<Card>
				<Text fontSize='xl' fontWeight='bold' mb={4}>Numerazione Rapporti d'Intervento</Text>
				{loading ? (
					<Flex justifyContent='center' alignItems='center' minH='80px'>
						<Spinner size='lg' />
					</Flex>
				) : (
					<>
						<FormControl mb={3}>
							<FormLabel>Prossimo numero rapporto</FormLabel>
							<Input
								type="number"
								min={1}
								_focus={{ boxShadow: 'black' }}
								value={nextNumber}
								onChange={(e) => setNextNumberValue(e.target.value)}
							/>
						</FormControl>
						<Button
							onClick={handleSave}
							isLoading={saving}
							_hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.600' }} _focus={{ boxShadow: 'none' }}
							backgroundColor='#688CC8' color="white"
							height="30px" borderRadius="6px" fontSize='sm'
						>
							Salva
						</Button>
					</>
				)}
			</Card>
		</Box>
	);
}
